import { render, staticRenderFns } from "./EditSurvey.vue?vue&type=template&id=61352c45"
import script from "./EditSurvey.vue?vue&type=script&lang=js"
export * from "./EditSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports